
































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { SorewardsProgram } from '@/models/index'
import { clipboardSuccess } from '@/utils/clipboard'
import SorewardsProgramTypeDisplay from '@/views/sorewards/programs/program-type-display.vue'

@Component({
  name: 'SorewardsProgramShow',
  components: {
    SorewardsProgramTypeDisplay
  }
})
export default class extends Vue {
  private program: SorewardsProgram = new SorewardsProgram()
  private loading = false
  private clipboardSuccess = clipboardSuccess

  created() {
    this.getProgram()
  }

  @Watch('$route')
  private onRouteChange() {
    if (this.$route.name !== 'SorewardsProgramShow') return
    this.getProgram()
  }

  private async getProgram() {
    this.loading = true
    this.program = new SorewardsProgram()

    try {
      const { data } = await SorewardsProgram.find(this.$route.params.id)
      this.program = data
    } catch (error) {
      if (error !== 'abort') {
        throw error
      }
    } finally {
      this.loading = false
    }
  }
}
